import ProcurementDetailView from '../views/public/ProcurementDetailView.svelte'
import DashboardView from '../views/admin/DashboardView.svelte'
import CertificateAnalysisView from '../views/admin/CertificateAnalysisView.svelte'
import SourcesView from '../views/admin/SourcesView.svelte'
import CollectionView from '../views/admin/CollectionView.svelte'
import IngestionRunsView from '../views/admin/IngestionRunsView.svelte'
import AiHistoryView from '../views/admin/AiHistoryView.svelte'
import NotificationsView from '../views/admin/NotificationsView.svelte'
import ArchiveView from '../views/admin/ArchiveView.svelte'
import FiltersView from '../views/admin/FiltersView.svelte'
import CompanyProfileView from '../views/admin/CompanyProfileView.svelte'
import NotFoundView from '../views/NotFoundView.svelte'

export const routes = {
  '/': DashboardView,
  '/procurements/:id': ProcurementDetailView,
  '/dashboard': DashboardView,
  '/certificate-analysis': CertificateAnalysisView,
  '/sources': SourcesView,
  '/collection': CollectionView,
  '/ingestion-runs': IngestionRunsView,
  '/ai-history': AiHistoryView,
  '/notifications': NotificationsView,
  '/archive': ArchiveView,
  '/filters': FiltersView,
  // Kept for old bookmarks/links — same view, new primary path is /filters.
  '/saved-filters': FiltersView,
  '/settings/company-profile': CompanyProfileView,
  '*': NotFoundView,
}
